import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const TenantContext = createContext();

const DEFAULT_BRANDING = {
    primary: '#d4af37',
    primaryLight: '#eacb6e',
    primaryDark: '#b5952f',
    primaryGlow: 'rgba(212, 175, 55, 0.4)',
    background: '#f8f6f0',
    logo: null,
};

/** Evita variables CSS inválidas (null) que parpadean la UI. */
export function normalizeBranding(raw) {
    if (!raw || typeof raw !== 'object') return { ...DEFAULT_BRANDING };
    const primary = raw.primary || DEFAULT_BRANDING.primary;
    return {
        primary,
        primaryLight: raw.primaryLight || raw.primary_light || primary,
        primaryDark: raw.primaryDark || raw.primary_dark || primary,
        primaryGlow: raw.primaryGlow || raw.primary_glow || DEFAULT_BRANDING.primaryGlow,
        background: raw.background || raw.background_color || DEFAULT_BRANDING.background,
        logo: raw.logo || raw.logo_url || null,
        tenantName: raw.tenantName || raw.tenant_name || null,
    };
}

export function TenantProvider({ children }) {
    const [branding, setBrandingState] = useState(() => {
        const saved = localStorage.getItem('alinea_branding');
        return saved ? normalizeBranding(JSON.parse(saved)) : { ...DEFAULT_BRANDING };
    });

    const setBranding = useCallback((newBranding) => {
        const next = normalizeBranding(newBranding);
        setBrandingState(next);
        localStorage.setItem('alinea_branding', JSON.stringify(next));
    }, []);

    // Efecto de inyección de marca blanca: Variables CSS al vuelo
    useEffect(() => {
        const root = document.documentElement;
        root.style.setProperty('--color-primary', branding.primary);
        root.style.setProperty('--color-primary-light', branding.primaryLight);
        root.style.setProperty('--color-primary-dark', branding.primaryDark);
        root.style.setProperty('--color-primary-glow', branding.primaryGlow);
        root.style.setProperty('--color-bg', branding.background);

        if (branding.tenantName) {
            document.title = `ALINEA | ${branding.tenantName}`;
        } else if (window.location.pathname.startsWith('/login')) {
            document.title = 'ALINEA';
        }
    }, [branding]);

    return (
        <TenantContext.Provider value={{ branding, setBranding }}>
            {children}
        </TenantContext.Provider>
    );
}

export const useTenant = () => useContext(TenantContext);
